module.exports = __webpack_public_path__ + "icoOrders.png";